/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');

const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');

require('./vertify-data.scss');
const template = require('./vertify-data.tpl');

const VertifyData = {
	name: "vertify-data",

	template,

	data() {
		return {
			url: apiPath.usersurvey.vertifyData,
			thItems: ["汽车品牌", "审核中", "未通过", "已通过","合计"],
			thItemSort: [
				{
					txt:'汽车品牌',
					isSort:0
				},
				{
					txt:'审核中',
					isSort:1,
				},
				{
					txt:'未通过',
					isSort:1,
				},
				{
					txt:'已通过',
					isSort:1
				},
				{
					txt:'合计',
					isSort:1
				}
			]
		}
	},

	ready() {
		// console.log(('Hello Vue.js!').split('').reverse().join(''))
	},

	store,

	methods: {
		sortTableCall(idx,stas){
			// console.log(idx,stas)
      this.$refs.tableData.query({
				"sortType": stas,
				"sortKey": idx
			}).fetch();
    }
	}
}

module.exports = VertifyData;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/userdata/vertify-data/vertify-data.js